<td class="col-standard">
  {{ lastInteraction }}
</td>
<td class="col-standard">
  {{ !loadingCourse && courseTitle }}
</td>
<td
  class="col-tribu"
  (click)="!loadingCourse &&
  onClickLocalRow(
    tribe
  )
  "
>
  {{ tribe.attributes.title }}
</td>
<td class="col-standard">
  {{ tribe.attributes.comment_forum.comment_count || "0" }}
</td>
<td class="col-standard">
  <span
    [ngClass]="{
      'status-activo': tribe.attributes.status === true,
      'status-cerrado': tribe.attributes.status === false
    }"
  >
    {{ tribe.attributes.status === true ? "Activo" : "Inactivo" }}</span
  >
</td>

